
import React from 'react'
import '../scss/RankingResultadoList.css'
import {formatMs} from '../utils/time'
import {Link} from 'react-router-dom'

const RankingResultadoList = (props) => {
  // ...
  if (props.ranking) {
    return <ul className='resultado-list'>
      {props.resultados.map((r) => (
        <li key={`resultado-${r.id}`} className='resultado-list__row' >
          <Link to={`/competicion/${r.competicion_id}/dorsal/${r.dorsal}`}>
            <div className='resultado-item'>
              <div className='resultado-item__puesto'>
                {r.puesto}
              </div>
              <div className='resultado-item__nombre'>
                {r.nombre} {r.apellidos}
              </div>
              <div className='resultado-item__tiempo'>
                {formatMs(r.valor)}
              </div>
              <div className='resultado-item__info'>
                Dorsal <strong>{r.dorsal}</strong>&nbsp;
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  } else {
    return null
  }
}

export default RankingResultadoList



// WEBPACK FOOTER //
// ./src/components/RankingResultadoList.js